/**
 * ****************************************************************************
 * @description     :   Route for app module
 * @created at      :   2025/11/05
 * @created by      :   HaiNN
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
// const Login = () => import('@/views/auth/login');
const PTJ_Login = () => import('@/views/mobile/ptj_auth/PTJ_Login');
const PTJ_Worker001 = () => import('@/views/mobile/ptj_worker/PTJ_Worker001');
const PTJ_Worker003 = () => import('@/views/mobile/ptj_worker/PTJ_Worker003');
const PTJ_Worker004 = () => import('@/views/mobile/ptj_worker/PTJ_Worker004');
const PTJ_Worker005 = () => import('@/views/mobile/ptj_worker/PTJ_Worker005');
const PTJ_Worker006 = () => import('@/views/mobile/ptj_worker/PTJ_Worker006');
const PTJ_Worker007 = () => import('@/views/mobile/ptj_worker/PTJ_Worker007');
const PTJ_Worker002 = () => import('@/views/mobile/ptj_worker/PTJ_Worker002');
const PTJ_Worker009 = () => import('@/views/mobile/ptj_worker/PTJ_Worker009');
const PTJ_Worker008 = () => import('@/views/mobile/ptj_worker/PTJ_Worker008');
const PTJ_Worker014 = () => import('@/views/mobile/ptj_worker/PTJ_Worker014');
const PTJ_Worker017 = () => import('@/views/mobile/ptj_worker/PTJ_Worker017');
const PTJ_Worker018 = () => import('@/views/mobile/ptj_worker/PTJ_Worker018');
const PTJ_Worker020 = () => import('@/views/mobile/ptj_worker/PTJ_Worker020');
const PTJ_Worker021 = () => import('@/views/mobile/ptj_worker/PTJ_Worker021');
const PTJ_Worker010 = () => import('@/views/mobile/ptj_worker/PTJ_Worker010');
const PTJ_Worker013 = () => import('@/views/mobile/ptj_worker/PTJ_Worker013');
const PTJ_Worker015 = () => import('@/views/mobile/ptj_worker/PTJ_Worker015');
const PTJ_Worker012 = () => import('@/views/mobile/ptj_worker/PTJ_Worker012');
const PTJ_Worker011 = () => import('@/views/mobile/ptj_worker/PTJ_Worker011');
const PTJ_Worker019 = () => import('@/views/mobile/ptj_worker/PTJ_Worker019');
const PTJ_Worker016 = () => import('@/views/mobile/ptj_worker/PTJ_Worker016');

/**
 * Defined Router
 */
export default [
    {
        path: '/PTJ_System/login',
        name: 'PTJ_Login',
        component: PTJ_Login,
        meta: {
            title: 'ログイン',
            layout: 'PTJEmptyLayout'
        }
    },
    {
        path: '/PTJ_Worker003',
        name: 'PTJ_Worker003',
        component: PTJ_Worker003,
        meta: {
            title: 'スタッフ登録情報',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker001',
        name: 'PTJ_Worker001',
        component: PTJ_Worker001,
        meta: {
            title: 'カレンダー',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker002',
        name: 'PTJ_Worker002',
        component: PTJ_Worker002,
        meta: {
            title: 'お仕事情報',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker004',
        name: 'PTJ_Worker004',
        component: PTJ_Worker004,
        meta: {
            title: 'アラーム設定',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker005',
        name: 'PTJ_Worker005',
        component: PTJ_Worker005,
        meta: {
            title: '労働条件通知書',
            layout: 'PTJEmptyLayout'
        }
    },
    {
        path: '/PTJ_Worker006',
        name: 'PTJ_Worker006',
        component: PTJ_Worker006,
        meta: {
            title: '終了報告',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker007',
        name: 'PTJ_Worker007',
        component: PTJ_Worker007,
        meta: {
            title: 'スケジ ュール登 録',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker009',
        name: 'PTJ_Worker009',
        component: PTJ_Worker009,
        meta: {
            title: '終了報告',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker008',
        name: 'PTJ_Worker008',
        component: PTJ_Worker008,
        meta: {
            title: 'メンバーリスト',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker014',
        name: 'PTJ_Worker014',
        component: PTJ_Worker014,
        meta: {
            title: '申請機能',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker017',
        name: 'PTJ_Worker017',
        component: PTJ_Worker017,
        meta: {
            title: '源泉徴収票申請',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker018',
        name: 'PTJ_Worker018',
        component: PTJ_Worker018,
        meta: {
            title: '源泉徴収票申請',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker020',
        name: 'PTJ_Worker020',
        component: PTJ_Worker020,
        meta: {
            title: '申請確認',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker021',
        name: 'PTJ_Worker021',
        component: PTJ_Worker021,
        meta: {
            title: '申請完了',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker010',
        name: 'PTJ_Worker010',
        component: PTJ_Worker010,
        meta: {
            title: 'スタッフ振 込先情報',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker013',
        name: 'PTJ_Worker013',
        component: PTJ_Worker013,
        meta: {
            title: '職務遵守事項',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker015',
        name: 'PTJ_Worker015',
        component: PTJ_Worker015,
        meta: {
            title: '源泉徴収票申請',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker012',
        name: 'PTJ_Worker012',
        component: PTJ_Worker012,
        meta: {
            title: 'パスワード設 定',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker011',
        name: 'PTJ_Worker011',
        component: PTJ_Worker011,
        meta: {
            title: 'ア ン ケ ー ト',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker019',
        name: 'PTJ_Worker019',
        component: PTJ_Worker019,
        meta: {
            title: '給 与 申 請 利 用 履 歴',
            layout: 'PTJLayout'
        }
    },
    {
        path: '/PTJ_Worker016',
        name: 'PTJ_Worker016',
        component: PTJ_Worker016,
        meta: {
            title: '口 座 情 報 変 更 申 請',
            layout: 'PTJLayout'
        }
    }
];
